import { render, staticRenderFns } from "./Landingpage.vue?vue&type=template&id=e5ae6d4a&scoped=true&"
import script from "./Landingpage.vue?vue&type=script&lang=js&"
export * from "./Landingpage.vue?vue&type=script&lang=js&"
import style0 from "./Landingpage.vue?vue&type=style&index=0&id=e5ae6d4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ae6d4a",
  null
  
)

export default component.exports